import React from 'react'
import { IonIcon, IonButton } from '@ionic/react'
import { useTranslation } from 'react-i18next'
import { camera } from 'ionicons/icons'
import { AppRouterConstants } from '../../../components/appRouter/AppRouter.constants'
import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { getCameraAttachmentsSelector } from '../selectors'

const CameraButton: React.FC = () => {
  const history = useHistory()
  const { t } = useTranslation()
  const cameraAttachmentsState = useSelector(getCameraAttachmentsSelector)
  const { disableCameraButton } = cameraAttachmentsState

  const onCameraButtonClick = () => {
    history.push(AppRouterConstants.CAMERA_ATTACHMENTS_ROUTE)
  }
  return (
    <IonButton
      data-testid='CameraButton'
      className='camera-button'
      expand='block'
      fill='clear'
      onClick={onCameraButtonClick}
      disabled={disableCameraButton}
      color='primary-alt'>
      <IonIcon icon={camera} size='large' />
      {t('cameraAttachments.camera')}
    </IonButton>
  )
}

export default CameraButton
